import React from 'react';
import { connect } from 'react-redux';
import dashdemo from '../assets/commercial-fire.svg';

const Home = props => (

  <div className="home-page-content">
    <img src={dashdemo} alt="Commercial Fire Logo" style={{marginTop: '148px'}}/>
    <h2 className="semi-bold-weight" style={{marginTop : '48px'}} id="blue">Welcome to Commercial Fire's work order
      management tool.</h2>
    <h3 className="light-weight" style={{marginTop : '8px'}} id="blue">Where you can manage all of your services with
      Commercial Fire.</h3>
  </div>
);

export default connect()(Home);
